export enum KeyUsage {
  GenuineCheck = "genuine_check",
  ExchangePayload = "exchange_payload",
  NftMeta = "nft_meta",
  TrustedName = "trusted_name",
  BackupProvider = "backup_provider",
  ProtectOrchestrator = "protect_orchestrator",
  PluginMeta = "plugin_meta",
  CoinMeta = "coin_meta",
  SeedIdAuth = "seed_id_auth",
  TxSimulationSigner = "tx_simu_signer",
  Calldata = "calldata",
  Network = "network",
  LESMultisig = "les_multisig",
  GatedSigning = "gated_signing",
  SwapTemplate = "swap_template",
}
